import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
} from "@material-ui/core";

const styles = (theme) => ({
  dialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    width: 400,
    userSelect: "none",
  },
  dialogTitleDefault: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
    padding: 0,
    color: theme.HeaderSelectedText,
  },
  dialogTitleWarning: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
    padding: 0,
    color: theme.violationsTextColor,
  },
  dialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  button: {
    fontSize: 14,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    width: "47%",
  },
  redButton: {
    backgroundColor: theme.violationsTextColor,
    color: theme.ModalBGColor,
  },
  dialogAction: {
    justifyContent: "space-between",
    margin: 0,
    "&$actionButton": {
      paddingBottom: 0,
      paddingRight: 0,
    },
  },
  actionButton: {
    margin: 0,
    padding: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  userInfo: {
    color: theme.HeaderSelectedText,
    fontWeight: "bold",
  },
  dialogMsg: {
    display: "flex",
    flexDirection: "column",
  },
});

const CustomConfirmationDialog = ({
  classes,
  title,
  children,
  onConfirm,
  onCancel,
  cancelButtonLabel,
  confirmButtonLabel,
  mode,
}) => {
  return (
    <Dialog
      open={true}
      aria-labelledby="UserDeletion-title"
      classes={{ paper: classes.dialog }}
      maxWidth="sm"
    >
      <DialogTitle
        id="UserDeletion-title"
        classes={{
          root:
            mode === "danger"
              ? classes.dialogTitleWarning
              : classes.dialogTitleDefault,
        }}
        disableTypography
      >
        {title}
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }}>
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {children}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <Grid container spacing={24}>
          <Grid item xs={12} classes={{ item: classes.actionButton }}>
            <Button
              variant="outlined"
              color={mode === "danger" ? "secondary" : "primary"}
              size="small"
              className={classes.button}
              onClick={onCancel}
            >
              {cancelButtonLabel}
            </Button>
            <Button
              variant="contained"
              color={mode !== "danger" ? "primary" : ""}
              size="small"
              disableRipple
              className={`${classes.button} ${
                mode === "danger" ? classes.redButton : ""
              }`}
              onClick={onConfirm}
            >
              {confirmButtonLabel}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(CustomConfirmationDialog);
